import {Component, HostListener, OnInit} from "@angular/core";
import {PageService} from "../../service/page/page.service";
import {PageInstagram} from "../../service/page/page";


@Component({
  selector: 'app-instagram',
  templateUrl: './instagram.component.html',
  styleUrls: ['./instagram.component.scss'],
  providers: [PageService]
})
export class InstagramComponent implements OnInit {
  isMobile: boolean = false;
  instagrams: PageInstagram[] = [];
  _origin: PageInstagram[] = [];

  @HostListener('window:resize', ['$event']) onResize(event) {
    let isMobile = (event.target.innerWidth < 768);
    if (this.isMobile != isMobile) {
      this.isMobile = isMobile;
      this.instagrams = this._origin.slice(0, this.isMobile ? 4 : 6);
    }
  }

  constructor(private pageService: PageService) {
  }

  ngOnInit(): void {
    this.isMobile = (window.innerWidth < 768);
    this.onInstagramInit();
  }

  onInstagramInit() {
    this.pageService.getInstagrams().subscribe(
      instagrams => {
        this._origin = instagrams;
        this.instagrams = instagrams.slice(0, this.isMobile ? 4 : 6);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/home/instagram/instagram.component.ts